import React from 'react';
import PropTypes from 'prop-types';

const ValidationError = ({ children }) => (
  <div className="form__error">{children}</div>
);

ValidationError.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ValidationError;
